/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=Avatar&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=Avatar&lang=js"

import "./index.vue?vue&type=style&index=0&id=418e06e7&lang=scss"

const __exports__ = script;

export default __exports__